// extracted by mini-css-extract-plugin
export default {"lukoil":"App_lukoil__djXg4","egis":"App_egis__4Fis1","main":"App_main__5VZ13"};